import API from "shared/services/Api";
import { IReferralCheckResponse } from "shared/types/ReferralCheck";

export const checkReferralNeeded = async (
  pacienteId: number,
  userId: string,
  procId?: number
): Promise<IReferralCheckResponse> =>
  API.get(`oc/referrals/patient/${pacienteId}/check-referral-needed?id=${userId}${procId ? `&procId=${procId}` : ''}`);














